import { Compass, Instagram } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { useLocalePath } from "@/hooks/useLocalePath";

const Footer = () => {
  const { t, language } = useLanguage();
  const { getPath } = useLocalePath();
  
  return (
    <footer id="about" className="bg-foreground text-primary-foreground py-16 px-6">
      <div className="container mx-auto">
        <div className="max-w-5xl mx-auto">
          <div className="flex flex-col md:flex-row items-start justify-between gap-8 mb-12">
            <div className="max-w-sm">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-10 h-10 rounded-full bg-primary-foreground/10 flex items-center justify-center">
                  <Compass className="w-5 h-5 text-primary-foreground" />
                </div>
                <span className="font-serif text-xl">
                  The Wise Compass
                </span>
              </div>
              <p className="text-primary-foreground/70 text-sm leading-relaxed">
                {t.footerDesc}
              </p>
            </div>

            <div className="flex flex-wrap gap-8 md:gap-12">
              {/* La Boussole Section */}
              <div>
                <h4 className="font-semibold mb-4">
                  {language === "fr" ? "La Boussole" : "The Compass"}
                </h4>
                <ul className="space-y-2 text-sm text-primary-foreground/70">
                  <li>
                    <Link to={getPath("/vision")} className="hover:text-primary-foreground transition-colors">
                      {language === "fr" ? "Notre Vision" : "Our Vision"}
                    </Link>
                  </li>
                  <li>
                    <Link to={language === "fr" ? "/fr/blog/methodologie-indicateur-mode-ecoresponsable" : "/blog/wise-compass-score-methodology"} className="hover:text-primary-foreground transition-colors">
                      {language === "fr" ? "Méthodologie" : "Methodology"}
                    </Link>
                  </li>
                  <li>
                    <Link to={getPath("/top-10")} className="hover:text-primary-foreground transition-colors">
                      {language === "fr" ? "Nos sélections" : "Our Selections"}
                    </Link>
                  </li>
                  <li>
                    <Link to={getPath("/faq")} className="hover:text-primary-foreground transition-colors">
                      {language === "fr" ? "FAQ" : "FAQ"}
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Contact Section */}
              <div>
                <h4 className="font-semibold mb-4">
                  {language === "fr" ? "Nous contacter" : "Contact us"}
                </h4>
                <ul className="space-y-2 text-sm text-primary-foreground/70">
                  <li>
                    <a href="https://form.typeform.com/to/I80twnpS" target="_blank" rel="noopener noreferrer" className="hover:text-primary-foreground transition-colors">
                      Contact
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/the_wise_compass/" target="_blank" rel="noopener noreferrer" className="hover:text-primary-foreground transition-colors flex items-center gap-2">
                      <Instagram className="w-4 h-4" />
                      Instagram
                    </a>
                  </li>
                </ul>
              </div>

              {/* Legal Section */}
              <div>
                <h4 className="font-semibold mb-4">{t.legal}</h4>
                <ul className="space-y-2 text-sm text-primary-foreground/70">
                  <li>
                    <Link to={getPath("/legal")} className="hover:text-primary-foreground transition-colors">
                      {language === "fr" ? "Mentions légales" : "Legal Notice"}
                    </Link>
                  </li>
                  <li>
                    <Link to={getPath("/privacy")} className="hover:text-primary-foreground transition-colors">
                      {t.privacyPolicy}
                    </Link>
                  </li>
                  <li>
                    <Link to={getPath("/terms")} className="hover:text-primary-foreground transition-colors">
                      {t.termsOfUse}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="border-t border-primary-foreground/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-primary-foreground/50">
            <p>© {new Date().getFullYear()} The Wise Compass. {t.badge}.</p>
            <p>{t.madeWith} 💚 {t.inFrance}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
